<template>
	<div class="dropdown-container position-relative col">
		<div
			class="dropdown-input dropdown border-default bg-primary-white w-100 outline-none caption d-flex align-items-center">
			<Participants
				@changeOpenParticipants="handleChangeOpenParticipants"
				@setParticipants="handleSetParticipants"
				@notEnoughAdults="handleNotEnoughAdults" />
		</div>
		<div
			class="label"
			style="z-index: 1">
			{{ content.planner_prestationsParticipants }}
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useStore } from "vuex"

// Components
import Participants from "@/vue/planning/components/search/participants.vue"

const store = useStore()
const content = computed(() => store.state.content)

const handleChangeOpenParticipants = (bool: boolean) => {
	store.dispatch("setParticipantsDropdownOpen", bool)
}

const handleSetParticipants = (newArray: Array<unknown>) => {
	store.dispatch("setParticipants", newArray)
}

const handleNotEnoughAdults = () => {
	store.commit("setErrorMessageOpen", "errorMessages_notEnoughAdults")
}
</script>

<style scoped>
.dropdown-input.dropdown {
	padding: 0px;
}
</style>
